import { IBasemapRepository, BasemapOptionEntity, BasemapConstant, BasemapProviderEnum, ResponseValueObject } from '@gishub/domain';

export class BasemapRepository implements IBasemapRepository {
  private static readonly G = ['0', '1', '2', '3'];
  private static readonly B = ['0', '1', '2', '3'];

  private static readonly items: BasemapOptionEntity[] = [
    {
      id: BasemapConstant.GOOGLE_MAPS, name: 'Google Calles', provider: BasemapProviderEnum.GOOGLE,
      image: 'assets/images/basemaps/streets_vector.png',
      urlTemplate: 'https://mt{subDomain}.google.com/vt/lyrs=r&x={x}&y={y}&z={z}',
      subDomains: BasemapRepository.G, type: 'raster',
      attribution: '© Google', maxZoom: 20,
    },
    {
      id: BasemapConstant.GOOGLE_SATELLITE, name: 'Google Satélite', provider: BasemapProviderEnum.GOOGLE,
      image: 'assets/images/basemaps/satellite.png',
      urlTemplate: 'https://mt{subDomain}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}',
      subDomains: BasemapRepository.G, type: 'raster',
      attribution: '© Google', maxZoom: 20,
      disabled: false,
    },
    {
      id: BasemapConstant.GOOGLE_HYBRID, name: 'Google Híbrido', provider: BasemapProviderEnum.GOOGLE,
      image: 'assets/images/basemaps/satellite.png',
      urlTemplate: 'https://mt{subDomain}.google.com/vt/lyrs=y&x={x}&y={y}&z={z}',
      subDomains: BasemapRepository.G, type: 'raster',
      attribution: '© Google', maxZoom: 20,
      disabled: false,
    },
    {
      id: BasemapConstant.GOOGLE_TERRAIN, name: 'Google Terreno', provider: BasemapProviderEnum.GOOGLE,
      image: 'assets/images/basemaps/topo_vector.png',
      urlTemplate: 'https://mt{subDomain}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}',
      subDomains: BasemapRepository.G, type: 'raster',
      attribution: '© Google', maxZoom: 20,
      disabled: true,
    },

    {
      id: BasemapConstant.BING_MAPS, name: 'Bing Calles', provider: BasemapProviderEnum.BING,
      image: 'assets/images/basemaps/streets_vector.png',
      urlTemplate: 'https://ecn.dynamic.t{subDomain}.tiles.virtualearth.net/comp/CompositionHandler/{q}?mkt=en-us&it=G,VE,BX,L,LA&shading=hill',
      subDomains: BasemapRepository.B, type: 'raster',
      attribution: '© Microsoft', maxZoom: 19,
      disabled: true,
    },
    {
      id: BasemapConstant.BING_SATELLITE, name: 'Bing Satélite', provider: BasemapProviderEnum.BING,
      image: 'assets/images/basemaps/satellite.png',
      urlTemplate: 'https://ecn.t{subDomain}.tiles.virtualearth.net/tiles/a{q}.jpeg?g=0',
      subDomains: BasemapRepository.B, type: 'raster',
      attribution: '© Microsoft', maxZoom: 19,
      disabled: true,
    },

    {
      id: BasemapConstant.ARCGIS_LIGHT_GRAY, name: 'ArcGIS Gris Claro', provider: BasemapProviderEnum.ARCGIS,
      image: 'assets/images/basemaps/streets_vector.png',
      urlTemplate: 'https://www.arcgis.com/sharing/rest/content/items/291da5eab3a0412593b66d384379f89f/resources/styles/root.json',
      subDomains: [], type: 'vector',
      attribution: '© Esri',
      disabled: true,
    },
    {
      id: BasemapConstant.ARCGIS_VECTOR, name: 'ArcGIS Vectorial', provider: BasemapProviderEnum.ARCGIS,
      image: 'assets/images/basemaps/streets_vector.png',
      urlTemplate: 'https://basemaps.arcgis.com/arcgis/rest/services/World_Basemap_v2/VectorTileServer',
      subDomains: [], type: 'vector',
      attribution: '© Esri',
      disabled: true,
    },
    {
      id: BasemapConstant.ARCGIS_STREETS, name: 'ArcGIS Calles', provider: BasemapProviderEnum.ARCGIS,
      image: 'assets/images/basemaps/streets_vector.png',
      urlTemplate: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}',
      subDomains: [], type: 'raster',
      attribution: '© Esri',
      disabled: true,
    },
    {
      id: BasemapConstant.ARCGIS_SATELLITE, name: 'ArcGIS Satélite', provider: BasemapProviderEnum.ARCGIS,
      image: 'assets/images/basemaps/satellite.png',
      urlTemplate: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
      subDomains: [], type: 'raster',
      attribution: '© Esri',
      disabled: true,
    },
    {
      id: BasemapConstant.ARCGIS_TOPO, name: 'ArcGIS Topográfico', provider: BasemapProviderEnum.ARCGIS,
      image: 'assets/images/basemaps/topo_vector.png',
      urlTemplate: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}',
      subDomains: [], type: 'raster',
      attribution: '© Esri',
    },
    {
      id: BasemapConstant.ARCGIS_DARK_GRAY, name: 'ArcGIS Gris Oscuro', provider: BasemapProviderEnum.ARCGIS,
      image: 'assets/images/basemaps/streets_vector.png',
      urlTemplate: 'https://www.arcgis.com/sharing/rest/content/items/5e9f15a8a8f84f4c8b6b8e3d2e0b7d9a/resources/styles/root.json',
      subDomains: [], type: 'vector',
      attribution: '© Esri',
    },
    {
      id: BasemapConstant.ARCGIS_NAVIGATION, name: 'ArcGIS Navegación', provider: BasemapProviderEnum.ARCGIS,
      image: 'assets/images/basemaps/streets_vector.png',
      urlTemplate: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Navigation_Map/MapServer/tile/{z}/{y}/{x}',
      subDomains: [], type: 'raster',
      attribution: '© Esri',
      disabled: true,
    },
    {
      id: BasemapConstant.ARCGIS_HYBRID, name: 'ArcGIS Híbrido', provider: BasemapProviderEnum.ARCGIS,
      image: 'assets/images/basemaps/satellite.png',
      urlTemplate: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
      subDomains: [], type: 'raster',
      attribution: '© Esri',
      disabled: true,
    },

    {
      id: BasemapConstant.OSM_STANDARD, name: 'OSM Estándar', provider: BasemapProviderEnum.OSM,
      image: 'assets/images/basemaps/streets_vector.png',
      urlTemplate: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
      subDomains: [], type: 'raster',
      attribution: '© OpenStreetMap contributors',
      minZoom: 0, maxZoom: 19,
      disabled: true,
    },
    {
      id: BasemapConstant.OSM_HUMANITARIAN, name: 'OSM Humanitario', provider: BasemapProviderEnum.OSM,
      image: 'assets/images/basemaps/streets_vector.png',
      urlTemplate: 'https://tile-{s}.openstreetmap.fr/hot/{z}/{x}/{y}.png',
      subDomains: ['a', 'b', 'c'], type: 'raster',
      attribution: '© OpenStreetMap contributors',
      minZoom: 0, maxZoom: 19,
      disabled: true,
    },
    {
      id: BasemapConstant.OSM_DE, name: 'OSM Alemania', provider: BasemapProviderEnum.OSM,
      image: 'assets/images/basemaps/streets_vector.png',
      urlTemplate: 'https://tile.openstreetmap.de/{z}/{x}/{y}.png',
      subDomains: [], type: 'raster',
      attribution: '© OpenStreetMap contributors',
      minZoom: 0, maxZoom: 18,
      disabled: true,
    },

    {
      id: BasemapConstant.ESRI_STREETS, name: 'Esri Calles', provider: BasemapProviderEnum.ESRI,
      image: 'assets/images/basemaps/streets_vector.png',
      urlTemplate: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}',
      subDomains: [], type: 'raster',
      attribution: '© Esri',
    },
    {
      id: BasemapConstant.ESRI_IMAGERY, name: 'Esri Imágenes', provider: BasemapProviderEnum.ESRI,
      image: 'assets/images/basemaps/satellite.png',
      urlTemplate: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
      subDomains: [], type: 'raster',
      attribution: '© Esri',
      disabled: true,
    },
    {
      id: BasemapConstant.ESRI_TOPO, name: 'Esri Topográfico', provider: BasemapProviderEnum.ESRI,
      image: 'assets/images/basemaps/topo_vector.png',
      urlTemplate: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}',
      subDomains: [], type: 'raster',
      attribution: '© Esri',
    },
    {
      id: BasemapConstant.ESRI_DARK_GRAY, name: 'Esri Gris Oscuro', provider: BasemapProviderEnum.ESRI,
      image: 'assets/images/basemaps/streets_vector.png',
      urlTemplate: 'https://services.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Dark_Gray_Base/MapServer/tile/{z}/{y}/{x}',
      subDomains: [], type: 'raster',
      attribution: '© Esri',
    },
    {
      id: BasemapConstant.ESRI_LIGHT_GRAY, name: 'Esri Gris Claro', provider: BasemapProviderEnum.ESRI,
      image: 'assets/images/basemaps/streets_vector.png',
      urlTemplate: 'https://services.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}',
      subDomains: [], type: 'raster',
      attribution: '© Esri',
      disabled: true,
    },
    {
      id: BasemapConstant.ESRI_NAVIGATION, name: 'Esri Navegación', provider: BasemapProviderEnum.ESRI,
      image: 'assets/images/basemaps/streets_vector.png',
      urlTemplate: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Navigation_Map/MapServer/tile/{z}/{y}/{x}',
      subDomains: [], type: 'raster',
      attribution: '© Esri',
      disabled: true,
    },

    {
      id: BasemapConstant.CARTODB_POSITRON, name: 'CartoDB Positron', provider: BasemapProviderEnum.CARTODB,
      image: 'assets/images/basemaps/streets_vector.png',
      urlTemplate: 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{scale}.png',
      subDomains: ['a', 'b', 'c', 'd'], type: 'raster',
      attribution: '© CartoDB',
      maxZoom: 19,
      disabled: true,
    },
    {
      id: BasemapConstant.CARTODB_DARK_MATTER, name: 'CartoDB Dark Matter', provider: BasemapProviderEnum.CARTODB,
      image: 'assets/images/basemaps/streets_vector.png',
      urlTemplate: 'https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{scale}.png',
      subDomains: ['a', 'b', 'c', 'd'], type: 'raster',
      attribution: '© CartoDB',
      maxZoom: 19,
      disabled: true,
    },

    {
      id: BasemapConstant.STAMEN_TONER, name: 'Stamen Toner', provider: BasemapProviderEnum.STAMEN,
      image: 'assets/images/basemaps/streets_vector.png',
      urlTemplate: 'https://stamen-tiles-{s}.a.ssl.fastly.net/toner/{z}/{x}/{y}{scale}.png',
      subDomains: ['a', 'b', 'c', 'd'], type: 'raster',
      attribution: '© Stamen Design',
      maxZoom: 20,
      disabled: true,
    },
    {
      id: BasemapConstant.STAMEN_WATERCOLOR, name: 'Stamen Acuarela', provider: BasemapProviderEnum.STAMEN,
      image: 'assets/images/basemaps/satellite.png',
      urlTemplate: 'https://stamen-tiles-{s}.a.ssl.fastly.net/watercolor/{z}/{x}/{y}.png',
      subDomains: ['a', 'b', 'c', 'd'], type: 'raster',
      attribution: '© Stamen Design',
      maxZoom: 18,
      disabled: true,
    },
    {
      id: BasemapConstant.STAMEN_TERRAIN, name: 'Stamen Terreno', provider: BasemapProviderEnum.STAMEN,
      image: 'assets/images/basemaps/topo_vector.png',
      urlTemplate: 'https://stamen-tiles-{s}.a.ssl.fastly.net/terrain/{z}/{x}/{y}{scale}.png',
      subDomains: ['a', 'b', 'c', 'd'], type: 'raster',
      attribution: '© Stamen Design',
      maxZoom: 18,
      disabled: true,
    },

    {
      id: BasemapConstant.OPEN_TOPO_MAP, name: 'OpenTopoMap', provider: BasemapProviderEnum.OTHER,
      image: 'assets/images/basemaps/topo_vector.png',
      urlTemplate: 'https://tile.opentopomap.org/{z}/{x}/{y}.png',
      subDomains: [], type: 'raster',
      attribution: '© OpenTopoMap contributors',
      minZoom: 0, maxZoom: 17,
      disabled: true,
    },
    {
      id: BasemapConstant.USGS_TOPO, name: 'USGS Topo', provider: BasemapProviderEnum.OTHER,
      image: 'assets/images/basemaps/topo_vector.png',
      urlTemplate: 'https://basemap.nationalmap.gov/arcgis/rest/services/USGSTopo/MapServer/tile/{z}/{y}/{x}',
      subDomains: [], type: 'raster',
      attribution: '© USGS',
      disabled: true,
    },
    {
      id: BasemapConstant.CYCLOSM, name: 'CyclOSM', provider: BasemapProviderEnum.OTHER,
      image: 'assets/images/basemaps/streets_vector.png',
      urlTemplate: 'https://{s}.tile-cyclosm.openstreetmap.fr/cyclosm/{z}/{x}/{y}.png',
      subDomains: ['a', 'b', 'c'], type: 'raster',
      attribution: '© OpenStreetMap contributors',
      maxZoom: 20,
      disabled: true,
    },
    {
      id: BasemapConstant.WIKIMEDIA, name: 'Wikimedia', provider: BasemapProviderEnum.OTHER,
      image: 'assets/images/basemaps/streets_vector.png',
      urlTemplate: 'https://maps.wikimedia.org/osm-intl/{z}/{x}/{y}.png',
      subDomains: [], type: 'raster',
      attribution: '© Wikimedia',
      minZoom: 0, maxZoom: 19,
      disabled: true,
    },
    {
      id: BasemapConstant.MTB_MAP, name: 'MTB Mapa', provider: BasemapProviderEnum.OTHER,
      image: 'assets/images/basemaps/topo_vector.png',
      urlTemplate: 'https://tile.mtbmap.cz/mtbmap_tiles/{z}/{x}/{y}.png',
      subDomains: [], type: 'raster',
      attribution: '© MTB Map',
      minZoom: 3, maxZoom: 17,
      disabled: true,
    },
  ];

  private static enabledItems(): BasemapOptionEntity[] {
    return BasemapRepository.items.filter(o => !o.disabled);
  }

  async getDefault(): Promise<ResponseValueObject<BasemapOptionEntity>> {
    const defaultBasemap = BasemapRepository.enabledItems().find(o => o.id === BasemapConstant.GOOGLE_HYBRID)!;
    return new ResponseValueObject(true, defaultBasemap);
  }

  async getAll(): Promise<ResponseValueObject<BasemapOptionEntity[]>> {
    return new ResponseValueObject(true, [...BasemapRepository.enabledItems()]);
  }
}
